const Containers = require('./services/containers');
const Eula = require('./services/eula');
const Events = require('./utils/events');
const IdentityInfo = require('./services/identity-info');
const Globals = require('./state/globals');
class PlatformXbs {

  static getInstance(productUuid, xbsEnvironmentShort) {
    if (!this._instance) {
      Globals.setXbsEnvironment(xbsEnvironmentShort);
      Globals.setXbsProductUuid(productUuid);
      this._instance = {
        Containers,
        Eula,
        IdentityInfo,
        Events
      };
    }
    return this._instance;

  }
}

module.exports = PlatformXbs;